import { render, staticRenderFns } from "./BasisCalcSelectEditor.vue?vue&type=template&id=c4d3a3c0&scoped=true&"
import script from "./BasisCalcSelectEditor.vue?vue&type=script&lang=js&"
export * from "./BasisCalcSelectEditor.vue?vue&type=script&lang=js&"
import style0 from "./BasisCalcSelectEditor.vue?vue&type=style&index=0&id=c4d3a3c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d3a3c0",
  null
  
)

export default component.exports